import type { Session } from '@classgo/shared';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from './types';

/**
 * `GET /me`: who the caller is, for the shell and the tenant context. Cached for the session.
 *
 * @param {ApiClient} api -- The client.
 * @returns Query options for `useQuery`, `useSuspenseQuery` and the router's loader.
 */
export const sessionQuery = (api: ApiClient) =>
  queryOptions({
    queryKey: ['me'],
    queryFn: () => api.request<Session>('/me'),
    staleTime: 5 * 60_000,
  });
